import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import moment from 'moment';
import * as React from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';

import {
  CELL_SPACING,
  CELL_WIDTH,
  DAY_GRAY,
  WEEKEND_GRAY,
} from '../../../../../../constants';

import { useSxStyles } from './useStyles';

export interface Props {
  viewStartDate: moment.Moment;
  daysInView: moment.Moment[];
  handleCalendarNavigation: (direction: string) => void;
  endOfRange: moment.Moment;
}

export const CalendarHeader: React.FC<Props> = ({
  viewStartDate,
  daysInView,
  handleCalendarNavigation,
  endOfRange,
}) => {
  const sxStyles = useSxStyles();

  const outOfRange = moment(daysInView[daysInView.length - 1]).isSameOrAfter(
    moment(endOfRange),
    'day',
  );

  if (!daysInView.length) return <div />;

  return (
    <Box>
      <>
        <Box
          sx={sxStyles.navigationWrapper}
          style={{ width: daysInView.length * (CELL_WIDTH + CELL_SPACING) }}
        >
          <IconButton
            size="medium"
            onClick={() => handleCalendarNavigation('LEFT')}
            disabled={daysInView[0].isSameOrBefore(moment(), 'day')}
          >
            <NavigateBefore fontSize="inherit" />
          </IconButton>

          <Box sx={sxStyles.startEndDates}>
            <TooltippedTruncatedText>
              {viewStartDate.format('ll')}
            </TooltippedTruncatedText>
            {'\xa0-\xa0'}
            <TooltippedTruncatedText>
              {daysInView[daysInView.length - 1].format('ll')}
            </TooltippedTruncatedText>
          </Box>

          <IconButton
            size="medium"
            onClick={() => handleCalendarNavigation('RIGHT')}
            disabled={outOfRange}
          >
            <NavigateNext fontSize="inherit" />
          </IconButton>
        </Box>
        <Box sx={sxStyles.dayCells}>
          {daysInView.map((day) => {
            const dayOfWeek = day.toDate().getDay();
            return (
              <Box
                key={day.format('DD-MM-YYYY')}
                style={{
                  backgroundColor:
                    dayOfWeek === 6 || dayOfWeek === 0
                      ? WEEKEND_GRAY
                      : DAY_GRAY,
                }}
                sx={sxStyles.dayCell}
              >
                {day.format('dd D')}
              </Box>
            );
          })}
        </Box>
      </>
    </Box>
  );
};
